// material-ui components
import React, { useEffect } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import styles from "../../assets/jss/material-dashboard-react/components/dropDownButtonStyle";
import { useBriefAndBestContext } from "../../context/BriefAndBestContext.js";

const useStyles = makeStyles(styles);

const useStyles2 = makeStyles((theme) =>
  createStyles({
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

export default function BriefAndBestDropDownFrequency() {
  const {
    setStepFrequency,
    stepFrequency,
    timeActivity,
    setTimeActivity,
    disabled,
  } = useBriefAndBestContext();

  const classes = useStyles();
  const classes2 = useStyles2();

  useEffect(() => {
    if (timeActivity) {
      setStepFrequency(timeActivity);
    }
    // eslint-disable-next-line
  }, [timeActivity]);

  const handleChange = (event) => {
    setTimeActivity(event.target.value);
    setStepFrequency(event.target.value);
  };

  return (
    <FormControl
      variant="outlined"
      style={{ marginBottom: "30px" }}
      className={classes.formControl}
      disabled={disabled}
    >
      <InputLabel id="demo-simple-select-filled-label">
        Tempo por semana
      </InputLabel>
      <Select
        labelId="demo-simple-select-filled-label"
        id="demo-simple-select-filled"
        onChange={handleChange}
        value={stepFrequency}
        className={classes2.selectEmpty}
      >
        <MenuItem value={0.4}>{"Menos de 4 horas"}</MenuItem>
        <MenuItem value={0.8}>{"De 4 a 19 horas"}</MenuItem>
        <MenuItem value={1}>{"De 20 a 40 horas"}</MenuItem>
        <MenuItem value={1.25}>{"Mais de 40 horas"}</MenuItem>
      </Select>
    </FormControl>
  );
}
